import { FC } from 'react';

// Components
import Match from '../../MatchList/Match/Match';

// Types
import { INormalizedMatchV2, ISubscriberInfo } from '../../../../../../packages/types';

interface Props {
  showMatch: boolean;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
  match?: INormalizedMatchV2;
}

const MatchRow: FC<Props> = ({ showMatch, handleClick, match }) => {
  if (!showMatch || !match) {
    return null;
  }

  return (
    <div className='match-row-wrapper p-0 tb:p-4'>
      <div className='match-tournament-container flex items-center pl-2 bg-tournamentHeaderBgColor h-5 tb:rounded-t-4'>
        <span className='match-tournament-name text-2 font-semibold text-hiContrast'>{match.tournament}</span>
      </div>
      <Match match={match} handleClick={handleClick} withBackgroundColor withBorderRadius />
    </div>
  );
};

export default MatchRow;
